export const GET_PRODUCT_DETAIL_START = `GET_PRODUCT_DETAIL_START`;
export const GET_PRODUCT_DETAIL_SUCCESS = `GET_PRODUCT_DETAIL_SUCCESS`;
export const GET_PRODUCT_DETAIL_ERROR = `GET_PRODUCT_DETAIL_ERROR`;